import NoChartsData from '../components/charts/no-charts-data/NoChartsData';

const withEmptyChart = (Component) => {
  const WrappedComponent = (props) => {
    if (!props.data || !props.data.length) {
      return <NoChartsData height='350px' />;
    }

    return <Component {...props} />;
  };

  WrappedComponent.displayName = `WithEmptyChart(${Component.displayName || Component.name || 'Component'})`;
  return WrappedComponent;
};

export default withEmptyChart;
